export const DATE_FORMAT = {
    DEFAULT: "HH:mm",
    DAY_MONTH_YEAR_HOUR_MINUTES: "DD MMM YYYY, HH:mm",
    DAY_MONTH_YEAR: "DD MMM YYYY",
    DAY_MONTH_YEAR_MOBILE_VERSION: "DD.MM.YYYY",
    HOUR_MINUTES: "HH:mm"
}
